var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"view-container"},[(_vm.route == 'login' || _vm.route == 'signup')?_c('HeaderComponent'):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":_vm.transitionName}},[_c('router-view')],1)],1),_vm._v(" "),(_vm.route !== 'login' && _vm.route !== 'signup')?_c('NavbarComponent'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54e48b7c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 280
// module chunks = 1